<template>
    <div class="relative flex h-14">
        <div class="flex w-full justify-between">
            <template v-if="!app.hideBranding">
                <!-- On the two-column Review page the logo gives way before the header button does,
                     so "Your move details" stays whole on a phone. Every other header is as before. -->
                <img
                    v-if="app.tenant?.logo"
                    :src="app.tenant.logo"
                    class="h-14 max-w-48"
                    :class="isMoveDetails ? 'min-w-0 shrink object-contain object-left' : null"
                />
                <SvgIcon
                    v-else
                    class="w-32"
                    name="movepro_logo"
                />
            </template>
            <div
                class="my-auto ml-auto flex justify-between gap-3"
                :class="isMoveDetails ? 'shrink-0' : null"
            >
                <a
                    v-if="tenantPhone"
                    :href="`tel:${tenantPhone}`"
                    class="text-muval-gray-1 my-auto block rounded-full px-1 py-1.5 text-sm lg:hidden"
                    @click="analytics.phoneClicked()"
                >
                    <SvgIcon
                        class="h-5 w-5"
                        name="system-phone"
                    />
                </a>
                <ViewBook
                    compact
                    class="lg:hidden"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import ViewBook from './utilities/ViewBook.vue';
import { useRoute } from 'vue-router';
import { useAppStore, useAnalyticsStore } from '@/store';
import { useTenantPhone } from '@/composables/useTenantPhone';

const app = useAppStore();
const route = useRoute();
// The header button reads "Your move details" here (see ViewBook)
const isMoveDetails = computed(
    () => app.twoColumnReviewEnabled && (route?.name === 'Review' || route?.name === 'Confirmed'),
);
const tenantPhone = useTenantPhone();
const analytics = useAnalyticsStore();
</script>
